import PropTypes from 'prop-types';
import authService from '../../services/AuthService';

const HasFeature = ({ feature, children, fallback }) => {
  if (!children) return null;
  if (!authService.hasFeature(feature)) {
    return fallback;
  }
  return children;
};

HasFeature.propTypes = {
  feature: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node,
  fallback: PropTypes.node,
};
HasFeature.defaultProps = {
  children: null,
  fallback: null,
};
export default HasFeature;
